/**
 * @file I18n实体类
 */
type Translation = Record<string, string>
type TranslationData = { [key: string]: string }

export class I18n {
  private mapping: Translation = {}
  constructor(mapping: Translation) {
    this.mapping = mapping
  }
  // compatible
  t(path: string, data: TranslationData = {}) {
    return this.$t(path, data)
  }
  $t(path: string, data: TranslationData = {}) {
    const mapping = this.mapping
    if (mapping[path]) {
      return this.template(mapping[path], data)
    }
    if (path.indexOf('.')) {
      return this.template(this.walk(path, mapping), data)
    }
    return path
  }

  private walk(path: string, data: Translation = {}) {
    const defaultValue = path
    const paths = path.split('.')
    let member: string | undefined = ''
    while ((member = paths.shift())) {
      if (
        data[member] &&
        typeof data[member] !== 'object'
      ) {
        return data[member]
      }
      data = data[member] as unknown as Translation
    }
    return defaultValue
  }

  private template(
    string: string,
    data: TranslationData = {}
  ) {
    return string.replace(
      /{{([\s\S]+?)}}/g,
      (_match: any, escapeValue: string | number) =>
        data[escapeValue] ? data[escapeValue] : ''
    )
  }
}
